import { ModBox } from '@jfs/ui-new'
import { useState } from 'react'
import { CheckBoxGroupItem } from '../../../../../components/ApiConfig'
import { useStores } from '../../../../../data/store'

const AllowNotification = ({
  showAllowNotification,
  isEditMode,
  index,
  setFieldValue,
  fieldName,
  allowNotification,
}: any) => {
  console.log('AllowNotification', allowNotification)
  const { addContactProfile } = useStores((store) => ({
    addContactProfile: store.onboarding.addContactProfile,
  }))

  const [allowAllNotifications, setAllowAllNotifications] = useState(allowNotification === 'All')
  const [isEmailChecked, setEmailChecked] = useState(allowNotification === 'EMAIL' || allowNotification === 'All')
  const [isSmsChecked, setSMSChecked] = useState(allowNotification === 'SMS' || allowNotification === 'All')

  const onNotificationGrpCheckChange = (isChecked: string) => {
    setAllowAllNotifications((prev) => {
      addContactProfile(`${index}`, 'allowNotification', prev ? '' : 'All')
      if (setFieldValue && fieldName) {
        setFieldValue(fieldName, prev ? '' : 'All')
      }
      setEmailChecked(!prev)
      setSMSChecked(!prev)
      return !prev
    })
  }

  const onNotifiationItemchange = (id: string, isChecked: boolean) => {
    console.log('id isChecked', id, isChecked)

    if (id === '1') {
      setSMSChecked(isChecked)
      if (isChecked) {
        addContactProfile(`${index}`, 'allowNotification', isChecked ? 'SMS' : '')
        if (setFieldValue && fieldName) {
          setFieldValue(fieldName, isChecked ? 'SMS' : '')
        }
      } else {
        setAllowAllNotifications(false)
      }
    }
    if (id === '2') {
      setEmailChecked(isChecked)
      if (isChecked) {
        addContactProfile(`${index}`, 'allowNotification', isChecked ? 'EMAIL' : '')
        if (setFieldValue && fieldName) {
          setFieldValue(fieldName, isChecked ? 'EMAIL' : '')
        }
      } else {
        setAllowAllNotifications(false)
      }
    }
    if ((isSmsChecked && id === '2') || (isEmailChecked && id === '1')) {
      addContactProfile(`${index}`, 'allowNotification', 'All')
      if (setFieldValue && fieldName) {
        setFieldValue(fieldName, 'All')
        setAllowAllNotifications(true)
      }
    }
  }

  return (
    <ModBox
      show={showAllowNotification}
      marginTop={32}
      borderWidth={1}
      borderRadius={8}
      borderColor={'BORDER_COLOR'}
      h={74}
      justifyContent={'center'}>
      <CheckBoxGroupItem
        onGroupCheckChange={onNotificationGrpCheckChange}
        headerLabel={'Allow Notifications'}
        listItems={[
          {
            apiId: '1',
            apiEndPoint: 'SMS',
            isSelected: isSmsChecked,
          },
          {
            apiId: '2',
            apiEndPoint: 'Email',
            isSelected: isEmailChecked,
          },
        ]}
        isAllSelected={allowAllNotifications}
        onItemCheckChange={onNotifiationItemchange}
        hasAccess={false}
        isEdit={isEditMode}
        isApiConfig={false}
      />
    </ModBox>
  )
}

export { AllowNotification }
